import { useFetch } from "@/lib/axios.config.ts";
import { ImageType } from "@/pages/challenges/types/common";
import { PaginationResponse } from "@/shared/types/api.types";
import {
  getNextPageParam,
  getPreviousPageParam,
  initialPageParam,
} from "@/shared/utils/query";
import { useMutation, useQuery } from "@tanstack/react-query";
import { infiniteQueryOptions } from "@tanstack/react-query";

type UserReferralResponse = {
  avatar: ImageType;
  full_name: string;
  username: string;
  is_premium: boolean;
  award: string;
  referred_at: string;
};

const useReferralCode = () => {
  return useMutation({
    mutationKey: ["referral"],
    mutationFn: async () =>
      (await useFetch.get<{ referral_code: string }>("users/ReferralCode"))
        .data,
  });
};

const useSomeReferredUsers = () => {
  return useQuery({
    queryKey: ["referredUsers"],
    queryFn: async () =>
      (
        await useFetch.get<PaginationResponse<UserReferralResponse>>(
          "users/ReferredUsers"
        )
      ).data,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

const useReferredUsers = () => {
  return infiniteQueryOptions({
    queryKey: ["challenges"],
    queryFn: async ({ pageParam }) => {
      const response = await useFetch.get<
        PaginationResponse<UserReferralResponse>
      >("/users/ReferredUsers", {
        params: {
          limit: 20,
          offset: pageParam,
        },
      });

      return response.data;
    },
    initialPageParam,
    getNextPageParam: getNextPageParam,
    getPreviousPageParam: getPreviousPageParam,
  });
};

export { useReferralCode, useSomeReferredUsers, useReferredUsers };
